"use strict";

export default {
  async register(_, payload) {
    const { api, email, password } = payload;

    try {
      const params = {
        email,
        password,
      };

      const res = await api.post("/users/register", params);
      // commit("setAccessToken", res.data.data.accessToken);
      // commit("setUser", res.data.data.user, { root: true });

      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async login({ commit }, payload) {
    const { api, email, password } = payload;

    try {
      const params = {
        email,
        password,
      };

      const res = await api.post("/users/login", params);

      commit("setAccessToken", res.data.data.accessToken);
      commit("setUser", res.data.data.user, { root: true });

      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async logout({ commit }, payload) {
    const { api } = payload;

    try {
      const res = await api.post("/users/logout");
      commit("setAccessToken", null);
      commit("setUser", null, { root: true });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async profile(_, payload) {
    const { api } = payload;

    try {
      const res = await api.get("/users/profile");
      return res.data;
    } catch (err) {
      console.error(err);
      // throw new Error(
      //   err.response.data.message || err.message || "Unknown error"
      // );
    }
  },

  async verifyEmail(_, payload) {
    const { api, token } = payload;

    try {
      const res = await api.post("/users/verify-email", { token });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async forgotPassword(_, payload) {
    const { api, email } = payload;

    try {
      const res = await api.post("/users/forgot-password", { email });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async resetPassword(_, payload) {
    const { api, ...rest } = payload;

    try {
      const res = await api.post("/users/reset-password", { ...rest });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },
};
